module.exports = __webpack_public_path__ + "img/top.1a54a020.png";